import { create } from 'zustand';
import { ProgramInvoiceEditData } from '@models/program-invoice';
import { ChildInfo } from '@models/chat';

interface ProgramInvoiceEditStore {
  data: ProgramInvoiceEditData;
  setData: (updater: (prev: ProgramInvoiceEditData) => ProgramInvoiceEditData) => void;
  children: ChildInfo[];
  setChildren: (children: ChildInfo[]) => void;
  resetData: () => void;
}

const initialState = {
  data: {},
  children: [],
};

export const useProgramInvoiceEditStore = create<ProgramInvoiceEditStore>((set) => ({
  ...initialState,
  setData: (updater) => set((state) => ({ ...state, data: updater(state.data) })),
  setChildren: (children) => set({ children }),
  resetData: () => set(initialState),
}));
